import React, { useState } from 'react';

import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphImage = ({ entity }) => {
  const useFreeform = entity.getIn(['field_use_freeform', 0, 'value'], false);
  const imageStyle = useFreeform ? 'crop_freeform_image' : 'teaser_large';

  const image = entity.getIn(['field_image', 0, 'styles', imageStyle], '');
  const imageLarge = entity.getIn(['field_image', 0, 'styles', 'popup_image'], '');
  const alt = entity.getIn(['field_image', 0, 'alt']);
  const caption = entity.getIn(['field_caption', 0, 'value'], '');

  const [modalOpen, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modalOpen);
  };

  return (
    <Container className="ParagraphImage" onClick={toggleModal} small>
      <Image
        alt={alt || caption}
        lazyload={false}
        src={image}
        className="ParagraphImage__image"
      />
      <div className="ParagraphImage__caption">{caption}</div>
      { modalOpen && (
        <div className="ParagraphImage__modal">
          <div className="ParagraphImage__modal__backdrop" />
          <div className="ParagraphImage__modal__inner">
            <a href={entity.getIn(['field_image', 0, 'styles', 'original'])} target="_blank" rel="noopener noreferrer" aria-label="image-link">
              <Image
                src={imageLarge}
                className="ParagraphImage__image__large"
              />
            </a>
          </div>
        </div>
      )}
    </Container>
  );
};

export default ParagraphImage;
